import { TCommunityForumResponse } from "../types/community-forum";
import { TCommunityForum } from '../types/community-forum';
import { AxiosDataReturn } from "../types/generic";
import api from './api-instance';

export const getCommunityForumList = async (page: number, limit: number): Promise<AxiosDataReturn<TCommunityForumResponse>> => {
  const response = await api.get<AxiosDataReturn<TCommunityForumResponse>>(`/forum-topics/admin?page=${page}&limit=${limit}`);
  return response.data;
};

export const updateForumStatus = async (id: string, status: 'approved' | 'rejected'): Promise<AxiosDataReturn<TCommunityForum>> => {
  const response = await api.patch<AxiosDataReturn<TCommunityForum>>(`/forum-topics/admin/${id}`, { status });
  return response.data;
};
